"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ExpandCollapse = _interopRequireDefault(require("../ExpandCollapse"));
var _utils = require("../utils");
var _props = require("../utils/props");
var _ExpandCollapseMiniControl = _interopRequireDefault(require("./ExpandCollapseMiniControl"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectContainerProps, selectedContainerPropTypes] = (0, _utils.selectSystemProps)([_utils.contentfulProps]);
const ExpandCollapseMini = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    onToggle = () => {},
    tokens = {},
    nativeID,
    initialOpen = false,
    dataSet,
    ...rest
  } = _ref;
  const expandCollapeMiniPanelId = 'ExpandCollapseMiniPanel';
  const handleChange = (openPanels, event) => {
    if (typeof onToggle === 'function') {
      const isOpen = openPanels.length > 0;
      onToggle(event, isOpen);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandCollapse.default, {
    onChange: handleChange,
    tokens: tokens,
    initialOpen: initialOpen ? [expandCollapeMiniPanelId] : [],
    ...selectContainerProps(rest),
    dataSet: dataSet,
    children: expandProps => /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandCollapse.default.Panel, {
      ...expandProps,
      panelId: expandCollapeMiniPanelId,
      variant: {
        mini: true
      },
      controlTokens: {
        // Remove unwanted look and feel from ExpandCollapse(background pressed, focus border and text underline)
        icon: null,
        borderColor: 'transparent',
        textLine: tokens.textLine ?? 'none',
        backgroundColor: 'transparent'
      }
      // TODO refactor
      // eslint-disable-next-line react/no-unstable-nested-components
      ,
      control: pressableState => /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandCollapseMiniControl.default, {
        pressableState: pressableState,
        ...rest
      }),
      controlRef: ref,
      nativeID: nativeID,
      children: children
    })
  });
});
ExpandCollapseMini.displayName = 'ExpandCollapseMini';
ExpandCollapseMini.propTypes = {
  ..._ExpandCollapseMiniControl.default.propTypes,
  ...selectedContainerPropTypes,
  /**
   * Function to call on pressing the panel's control, which should open or close the panel.
   */
  onToggle: _propTypes.default.func,
  /**
   * ID for DOM element on web
   */
  nativeID: _propTypes.default.string,
  /**
   * Children nodes that can be added
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Controls if the panel and the content is opened by default on the first load
   */
  initialOpen: _propTypes.default.bool,
  /**
   * Optional variant object to override the default theme tokens
   */
  tokens: (0, _utils.getTokensPropType)('ExpandCollapseMini'),
  /**
   * ExpandCollapseMini variant.
   */
  variant: _props.variantProp.propType,
  /**
   * The dataSet prop allows to pass data-* attributes element to the component.
   */
  dataSet: _propTypes.default.object
};
var _default = exports.default = ExpandCollapseMini;